import React from 'react';
import { Typography } from '@material-ui/core';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { IQuizFormInput, IQuizFormValues } from '../../../quiz.types';
import { StyledScaleButton, StyledScaleFieldError, StyledScaleLabelsRow, StyledScaleRow } from './styles';

// ---------------------------------------------------------------------------
// Scale (horizontal 1–N)
// ---------------------------------------------------------------------------
export function ScaleInput({ input }: { input: IQuizFormInput }): JSX.Element {
  const { t } = useTranslation();
  const { control, errors } = useFormContext<IQuizFormValues>();
  const min = input.minAnswer ?? 1;
  const max = input.maxAnswer ?? 10;
  const steps = Array.from({ length: max - min + 1 }, (_, i) => min + i);
  const error = (errors?.answers as any)?.[input.id]?.value?.message as
    | string
    | undefined;

  return (
    <Controller
      name={`answers.${input.id}.value`}
      control={control}
      defaultValue=""
      rules={{
        required: input.isRequired
          ? (t('quiz.form.errors.required') as string)
          : false,
      }}
      render={({ onChange, value }) => (
        <div>
          <StyledScaleLabelsRow>
            {input.formInputChoices[0] && (
              <Typography variant="caption" color="textSecondary">
                {input.formInputChoices[0].title}
              </Typography>
            )}
            {input.formInputChoices[1] && (
              <Typography variant="caption" color="textSecondary">
                {input.formInputChoices[1].title}
              </Typography>
            )}
          </StyledScaleLabelsRow>
          <StyledScaleRow>
            {steps.map((n) => (
              <StyledScaleButton
                key={n}
                className={value === String(n) ? 'selected' : undefined}
                onClick={() => onChange(String(n))}
                type="button"
                disableElevation
              >
                {n}
              </StyledScaleButton>
            ))}
          </StyledScaleRow>
          {error && (
            <StyledScaleFieldError>
              {error}
            </StyledScaleFieldError>
          )}
        </div>
      )}
    />
  );
}
